import { useQuery } from "@tanstack/react-query";
import { getGoogleAdsMappings } from "../../api/bGoogleAdsApi";

export const useGetGoogleAdsMappings = (organisationId) => {
  return useQuery({
    queryKey: ["google-ads-mappings", organisationId],
    queryFn: () => getGoogleAdsMappings(organisationId),
    enabled: !!organisationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    onError: (error) => {
      console.error("Error fetching Google Ads mappings:", error.response || error);
    },
  });
};
